import { ReactNode, useMemo } from 'react';
import { apiEnvironment, reactQueryDebuggerEnabled } from '@/data/environment';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { useTsr } from './tsr';
import { TrpcWrapper } from '@/api/trpc';

const ONE_HOUR_MS = 60 * 60 * 1000;

export default function ToroSession({ children }: { children: ReactNode }) {
  const queryClient = useMemo(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            refetchOnWindowFocus: true,
            staleTime: ONE_HOUR_MS,
          },
        },
      }),
    []
  );
  const tsr = useTsr();

  return (
    <QueryClientProvider client={queryClient}>
      {reactQueryDebuggerEnabled && <ReactQueryDevtools />}
      <tsr.ReactQueryProvider>
        <TrpcWrapper apiUrl={apiEnvironment.baseUrl}>{children}</TrpcWrapper>
      </tsr.ReactQueryProvider>
    </QueryClientProvider>
  );
}
